<template>
  <div>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" align="center">
        <router-link to="/">
          <v-img src="@/assets/gpo_ips.png" width="40%" />
        </router-link>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-form @submit.prevent="login">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>{{ $t("iniciar_sesion") }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                :label="$t('correo_electronico')"
                name="email"
                prepend-icon="mdi-account"
                type="text"
                v-model="email"
                autocomplete="off"
                autofocus
              />

              <v-text-field
                id="password"
                :label="$t('contrasena')"
                name="password"
                prepend-icon="mdi-lock"
                v-model="password"
                autocomplete="off"
                type="password"
              />

              <v-select
                :label="$t('lenguaje')"
                id="lenguaje"
                name="lenguaje"
                prepend-icon="mdi-translate"
                v-model="lenguaje"
                :items="lenguajes"
                @change="cambiarLenguaje"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="primary">{{ $t("ingresar") }}</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    filesUrl: `http://${window.location.hostname}:${process.env.VUE_APP_ASSET_PORT}/`,
    notifications: [],
    email: "",
    password: "",
    lenguaje: window.localStorage.lenguaje || "es",
    lenguajes: [
      { text: "Español", value: "es" },
      { text: "English", value: "en" },
    ],
  }),
  methods: {
    cambiarLenguaje() {
      window.localStorage.lenguaje = this.lenguaje;
      this.$root.$i18n.locale = this.lenguaje;
      window.location = "/";
    },
    async login() {
      this.openLoader();
      const request = await this.sendRequest(
        `${this.$store.state.proveedorUrl}login`,
        {
          email: this.email,
          password: window.btoa(this.password),
          lenguaje: this.lenguaje,
        },
        "POST"
      );
      if (request.success) {
        const { data, message } = request;
        window.localStorage.setItem("token", data.token);
        window.localStorage.setItem("user", JSON.stringify(data.usuario));
        window.localStorage.lenguaje = this.lenguaje;
        this.showSuccessMessage(message);
        this.$store.state.user = data.usuario;
        window.setTimeout(() => {
          window.location = "/";
        }, 3000);
      }
      this.closeLoader();
    },
  },
};
</script>
